// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:23:07

export default {
  "id": "agent-squad",
  "slug": "agent-squad",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5721187248f248b6a1a9bd4787ddf934-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5721187248f248b6a1a9bd4787ddf934/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Agent Squad",
      "description": "Looking for an engaging casual shooter that’s easy to get the hang of but offers engrossing action and real tactical challenges? \nAgent Squad is a top-down shooting game with intelligent mechanics, loads of cool upgradable guns, and addictive gameplay",
      "instructions": "The gameplay is very simple, slide the screen or use keyboard to move and defeat all the enemies to successfully enter the next level.\nMore cool guns are waiting for you to unlock!\nJoin now, press the trigger wildly and feel the fun of shooting the game you! \nHave fun!",
      "genres": [
        "Agility",
        "Shooter"
      ],
      "tags": [
        "1player",
        "3d",
        "agent",
        "assassin",
        "guns"
      ]
    },
    "zh-CN": {
      "title": "特工小队",
      "description": "寻找一款引人入胜的休闲射击游戏，易于上手却提供沉浸式动作和真实战术挑战？特工小队是一款俯视角射击游戏，拥有智能机制、众多酷炫可升级枪械和上瘾的游戏玩法。",
      "instructions": "游戏玩法非常简单，滑动屏幕或使用键盘移动并击败所有敌人，成功进入下一关！更多酷炫的枪械等你解锁！现在加入，狂按扳机，感受射击游戏的乐趣！\n玩得开心！",
      "genres": [
        "敏捷性",
        "射击"
      ],
      "tags": [
        "1玩家",
        "3D",
        "特工",
        "刺客",
        "枪支"
      ]
    },
    "zh-TW": {
      "title": "特勤小隊",
      "description": "尋找一個引人入勝的輕鬆射手遊戲，容易上手但提供深入人心的動作和真實的戰術挑戰？ \nAgent Squad 是一款俯視射擊遊戲，具有智能機制、許多酷炫可升級的槍械，以及上癮的遊戲玩法",
      "instructions": "遊戲玩法非常簡單，滑動螢幕或使用按鍵移動，擊敗所有敵人即可成功進入下一關！\n更多酷炫槍械正等待您來解鎖！\n馬上加入，瘋狂按壓扳機，感受遊戲的樂趣！\n快樂遊玩！",
      "genres": [
        "敏捷度",
        "射手"
      ],
      "tags": [
        "1 玩家",
        "3D",
        "代理人",
        "刺客",
        "槍械"
      ]
    },
    "zh-HK": {
      "title": "探員小隊",
      "description": "尋找一個易於上手但同時提供深入動作和真實戰術挑戰的輕鬆射擊遊戲？Agent Squad 是一款俯視射擊遊戲，具有智能機制、眾多酷炫可升級的槍械，以及上癮的遊戲玩法。",
      "instructions": "遊戲操作非常簡單，滑動螢幕或使用鍵盤移動，擊敗所有敵人即可成功進入下一關！\n更多酷炫的槍械等你解鎖！\n立即加入，狂按扳機，感受射擊遊戲的樂趣！\n開心享受！",
      "genres": [
        "靈巧度",
        "射擊"
      ],
      "tags": [
        "1人遊玩",
        "3D",
        "代理人",
        "刺客",
        "槍械"
      ]
    },
    "ja": {
      "title": "エージェント・スクワッド",
      "description": "面白いカジュアルシューティングゲームを探してるけど、簡単に上達できるけど魅力的なアクションと本格的な戦術的な挑戦が提供されるものを？エージェント・スクワッドは、賢いメカニクスを持つトップダウンシューティングゲームで、たくさんのクールなアップグレード可能な銃があり、魅力的なゲームプレイが楽しめる。",
      "instructions": "ゲームプレイは非常にシンプルです。スクリーンをスライドしたり、キーボードを使って移動し、すべての敵を倒して次のレベルに成功して進みましょう！\nもっとクールな銃があなたを待っています！今すぐ参加して、トリガーを乱射し、ゲームの楽しさを感じてください！\n楽しい時間を過ごしましょう！",
      "genres": [
        "素早さ",
        "射撃"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "エージェント",
        "暗殺者",
        "銃"
      ]
    },
    "ko": {
      "title": "에이전트 스퀘드",
      "description": "Engaging한 캐주얼 쏘나이어를 찾고 계신가요? 쉽게 익히면서도 흥미진진한 액션과 진정한 전략적 도전을 제공하는 것? \nAgent Squad은 지능적인 기계식, 많은 멋진 업그레이드 가능한 무기, 그리고 약간의 게임 플레이가 중독성을 가지는 푸즈다운 쏘나이어 게임입니다.",
      "instructions": "게임 플레이는 매우 간단합니다. 스크린을 슬라이드하거나 키보드를 사용하여 이동하여 모든 적을 물리치고 다음 레벨에 성공적으로 진입하세요!\n더 많은 쿨한 건이 여러분을 기다리고 있습니다!\n지금 가입하세요, 트리거를 열심히 눌러서 쏘는 게임의 재미를 느껴보세요! \n즐거워요!",
      "genres": [
        "순수성",
        "총알맞춤"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "에이전트",
        "암살자",
        "총"
      ]
    },
    "fr": {
      "title": "Escorte d'agents",
      "description": "Recherchez un tirelire casual captivant qui soit facile à maîtriser mais offre des actions captivantes et des défis tactiques réels ? Agent Squad est un jeu de tir à vue de dessus avec des mécanismes intelligents, une multitude d'armes sympas à améliorer et un gameplay accrocheur.",
      "instructions": "Le gameplay est très simple, glissez l'écran ou utilisez le clavier pour vous déplacer et vaincre tous les ennemis pour réussir à passer au niveau suivant.\nPlus de fusils cool vous attendent à déverrouiller !\nRejoignez-nous maintenant, tirez frénétiquement sur la gâchette et ressentez le plaisir de jouer à ce jeu ! \nAmusez-vous bien !",
      "genres": [
        "Agilité",
        "Tiroir"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "agent",
        "assassin",
        "armes à feu"
      ]
    }
  }
};
